import i18n from './i18n';

export function translate(key: string) {
  return i18n.global.t(key);
}